import { createContext, useContext } from 'react';

import type { SideNavContextValue } from 'components/navigation/side_nav/SideNav';

export const SideNavContext = createContext({} as SideNavContextValue);
SideNavContext.displayName = 'SideNavContext';

export const useSideNav = () => useContext(SideNavContext);